import { render, staticRenderFns } from "./chainPage2.vue?vue&type=template&id=1463b53a&scoped=true"
import script from "./chainPage2.vue?vue&type=script&lang=js"
export * from "./chainPage2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1463b53a",
  null
  
)

export default component.exports